// src/modules/app-views/_apps/appsindico/units/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const unitsInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [dropdownParameters, dropdownDivider],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default unitsInitMenuButton;
